export const BOXES_BASE_PATH = 'boxes';

export const generateOpenPath = (boxId: string): string => `${BOXES_BASE_PATH}/${boxId}/open`;
export const generateStateVerificationPath = (boxId: string): string => `${BOXES_BASE_PATH}/${boxId}/state-verification`;
